document.addEventListener('DOMContentLoaded', () => {
  const $select = document.querySelectorAll('select[name="archive-dropdown"], .postform');

  $select.forEach((element) => {
    // 新しいdiv要素を作成
    const $wrapper = document.createElement('div');
    $wrapper.classList.add('lito-select-wrapper');

    // 元の要素をwrapperで包む
    element.parentNode.insertBefore($wrapper, element);
    $wrapper.appendChild(element);
  });
});
